import { render, staticRenderFns } from "./OrganizationAndUser.vue?vue&type=template&id=1223172f&scoped=true"
import script from "./OrganizationAndUser.vue?vue&type=script&lang=js"
export * from "./OrganizationAndUser.vue?vue&type=script&lang=js"
import style0 from "./OrganizationAndUser.vue?vue&type=style&index=0&id=1223172f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1223172f",
  null
  
)

export default component.exports